import React from 'react';
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined';

import InfoListItem from '../InfoListItem';
import useBooking from '../../../../../../context/useBooking';

const LocationInfoListItem = () => {
	const { booking } = useBooking()

	return (
		<InfoListItem
			icon={PlaceOutlinedIcon}
			info={booking?.car?.office?.address}
			description=""
		/>
	);
};

export default LocationInfoListItem;
